import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=486ed1bd&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486ed1bd')) {
      api.createRecord('486ed1bd', component.options)
    } else {
      api.reload('486ed1bd', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=486ed1bd&", function () {
      api.rerender('486ed1bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FdOju7M4rfC8/JS/cancellationPolicy.vue"
export default component.exports